import React from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import { Container, Typography, Box, Paper, useTheme, Divider, Link } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
  const isAuthenticated = !!Cookies.get('token');
  const theme = useTheme();
  const darkMode = theme.palette.mode === 'dark';

  return (
    <Box sx={{ position: 'relative', height: '100vh', width: '100vw', overflowX: 'hidden', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1, position: 'fixed' }}>
        <Particles />
      </div>
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', pt: { xs: '90px', md: '100px' }, pb: 4 }}>
        <Container maxWidth="md">
          <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: '24px', background: darkMode ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.8)', backdropFilter: 'blur(10px)', border: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)', color: darkMode ? 'rgba(255,255,255,0.85)' : '#333' }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', textAlign: 'center' }}>
              Privacy Policy
            </Typography>
            <Typography variant="subtitle1" sx={{ textAlign: 'center', mb: 4, opacity: 0.7 }}>
              Last updated: April 2026
            </Typography>
            <Divider sx={{ mb: 4, borderColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>1. Information We Collect</Typography>
            <Typography variant="body1" paragraph>
              At LinkLearning (<Link href="https://linklearning.net/" target="_blank" color="inherit">https://linklearning.net/</Link>), we collect information to provide better services to our users. This includes personal information you provide when creating an account (such as your username, email address, and encrypted password) and data related to your usage of our platform, features, and games.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>2. How We Use Your Information</Typography>
            <Typography variant="body1" paragraph>
              The information we collect is used to operate and maintain the platform, manage your account, process token transactions and rank progression, and communicate with you regarding updates, security alerts, and support messages.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>3. Data Protection and Security</Typography>
            <Typography variant="body1" paragraph>
              We implement industry-standard security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. We do not sell, trade, or rent your personal identification information to third parties.
            </Typography>
            
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>4. Your Rights</Typography>
            <Typography variant="body1" paragraph>
              You have the right to access, update, or request the deletion of your personal data stored on our servers. If you wish to exercise these rights or have concerns about how your data is handled, please contact us at <strong>official.linklearning@gmail.com</strong>.
            </Typography>

          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;